const stateCustomField = [
    {
        field_name: 'countryMasterId',
        label: 'Country',
        type: "string",
        isRequired: true
    },
    {
        field_name: 'name',
        label: 'State',
        type: "string",
        isRequired: true
    },
    {
        field_name: 'status',
        label: 'Status',
        type: "string",
        isRequired: true
    }
];



export const Constant = {
    stateCustomField
}
